/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ProgressRoute extends Route {
  // Services
  @service
  store;

  model() {
    let group = this.modelFor('group');

    return hash({
      group,
      milestones: this.store.query('milestones/milestone', {
        progressionType: ProgressionType.PROGRESSION,
      }),
      milestoneSets: this.store.query('milestones/milestone-set', {
        include: 'milestones',
      }),
      subjects: this.store.query('goals/subject', { trackable: true }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    model.subjects = model.subjects
      .slice()
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
  }
}
